import React from 'react';
import { Create, SimpleForm, TextInput } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import AppBarSaveActions from '../components/AppBarSaveActions.tsx';

const IndustryCreate: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/industry">
          Industries
        </MuiLink>
        <Typography color="text.primary">Create</Typography>
      </Breadcrumbs>
      <Create mutationMode="pessimistic">
        <SimpleForm toolbar={<AppBarSaveActions showDelete={false} />}>
          <Container maxWidth="md">
            <Typography variant="h6" gutterBottom>
              New Industry
            </Typography>
            <TextInput source="name" helperText={false} fullWidth />
          </Container>
        </SimpleForm>
      </Create>
    </Container>
  );
};

export default IndustryCreate;
